import { FaCode, FaServer, FaMobileAlt, FaChild } from "react-icons/fa";

export interface Project {
  title: string;
  description: string;
  technologies: string[];
  features: string[];
  gradientFrom: string;
  gradientTo: string;
  icon: typeof FaCode;
  url?: string;
  iosUrl?: string;
}

export const PROJECTS: Project[] = [
  {
    title: "Litrlly",
    description:
      "AI-powered ecosystem for high-stakes English mastery. Features 1:1 IELTS exam simulation, dynamic interview practice, and phonetic-level pronunciation analysis.",
    technologies: ["React", "TypeScript", "Azure Speech Services", "Node.js"],
    features: [
      "IELTS exam simulation",
      "AI interview practice",
      "24/7 AI coaching",
    ],
    gradientFrom: "from-blue-500",
    gradientTo: "to-indigo-500",
    icon: FaMobileAlt,
    url: "https://litrlly.app",
    iosUrl: "https://apps.apple.com/app/litrlly-speak-english-better/id6740519737",
  },
  {
    title: "Litrlly iOS App",
    description:
      "Native iOS app for high-stakes English mastery. Digital reproduction of IELTS speaking test with instant scoring, dynamic interview practice with context-aware AI, and 24/7 personalized coaching.",
    technologies: ["React Native", "TypeScript", "Azure Speech Services", "iOS"],
    features: [
      "1:1 IELTS simulation",
      "Voice analysis",
      "Adaptive learning paths",
    ],
    gradientFrom: "from-purple-500",
    gradientTo: "to-pink-500",
    icon: FaMobileAlt,
    iosUrl: "https://apps.apple.com/ca/app/litrlly-app/id6758524303",
  },
  {
    title: "Litrlly Kids",
    description:
      "Fun English learning app designed for children. Interactive and engaging way for kids to learn English pronunciation.",
    technologies: ["React", "TypeScript", "Azure Speech Services", "Node.js"],
    features: ["Kid-friendly UI", "Fun learning", "Safe environment"],
    gradientFrom: "from-pink-500",
    gradientTo: "to-orange-500",
    icon: FaChild,
    url: "https://kids.litrlly.app",
  },
  {
    title: "api.modo",
    description:
      "RESTful API project built with TypeScript. Demonstrates backend architecture patterns and API design best practices.",
    technologies: ["TypeScript", "Node.js", "REST API", "Express"],
    features: ["Open source", "TypeScript-first", "Well documented"],
    gradientFrom: "from-blue-500",
    gradientTo: "to-purple-500",
    icon: FaCode,
  },
  {
    title: "api.medeor",
    description:
      "Medical demo application API built with TypeScript. Showcases healthcare-related data handling and secure API development.",
    technologies: ["TypeScript", "Node.js", "Healthcare", "API"],
    features: ["Demo application", "Clean architecture", "TypeScript"],
    gradientFrom: "from-green-500",
    gradientTo: "to-teal-500",
    icon: FaServer,
  },
];
